export default __webpack_public_path__ + "static/media/couple.cd676c86.svg";